import styled from "styled-components";

export const ImagePngContainer = styled.picture`
	display: inline-flex;
`;
